export enum UserStatus {
    LoggedUser = "LOGGED_USER",
    KnownUser = "KNOWN_USER",
    NewClient = "NEW_CLIENT",
}
